module.exports = __webpack_public_path__ + "static/media/codeform.17a63699.svg";